export class SelectedCondition {
    selectedConditionId: string;
    selectedCondition: any;
    selectedValue: any;
}
